// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__11zD_","file":"styles_file__aQpGE"};